<template>
  <router-view />
</template>

<style lang="scss">
/* Import organized styles */
@import "./styles/main.scss";

#app {
  font-family: "PPMori", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app * {
  // outline: 1px solid #00000080;
}

// remove the default margin
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Global styles */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "PPMori";
  font-weight: 600;
}

p,
span,
a,
li,
button,
input,
textarea {
  font-family: "PPMori";
  font-weight: 400;
}

//  class="hidden lg:flex w-5/12 bg-gradient-to-br from-purple-950 to-purple-600 flex-col px-12 xl:px-16 relative"

/* Additional Mobile Responsive Enhancements */
@media (max-width: 768px) {
  .sidebar-title {
    @apply text-3xl;
  }

  .sidebar-icon-circle {
    @apply w-16 h-16 text-3xl;
  }

  .sidebar-description {
    @apply text-lg;
  }

  .step-content-title {
    @apply text-xl;
  }

  .cta-title {
    @apply text-xl;
  }
}

@media (max-width: 480px) {
  .step-content-area {
    @apply px-4;
  }

  .step-content {
    @apply p-2;
  }

  .step-content-card {
    @apply p-4;
  }

  .household-grid {
    @apply grid-cols-2;
  }

  .location-grid {
    @apply grid-cols-1;
  }

  .connection-grid {
    @apply grid-cols-1;
  }

  .contact-form-grid {
    @apply grid-cols-1;
  }

  .battery-recommendation-card {
    @apply p-3;
  }
}
</style>
